import { Injectable } from '@angular/core';

import { environment } from '../../environments/environment';
import { Lang } from '../models/lang';

@Injectable({
  providedIn: 'root'
})
export class LangService {

  private currentLang: Lang = (environment.defaultLang === 'en') ? 'en' : 'ja';

  constructor() { }

  setCurrentLang(lang: Lang) {
    this.currentLang = lang;
  }

  getCurrentLang(): Lang {
    return this.currentLang;
  }

  getAppUrl(): string {
    return environment.baseUrl + '/' + this.currentLang;
  }
}
